import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { Button } from 'common-src/components/base';

import { ModalType } from 'src/components/base/ModalGroup';
import { openModal } from 'src/features/modals';

import styles from './SecureMessagingSend.module.scss';

const SecureMessagingSend = ({ patientId }) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <h3 className={[styles.title, 'font-s-24', 'font-w-700'].join(' ')}>
        Send Message To Patient Portal
      </h3>
      <Button
        id="send-secure-message-button"
        text="Send Message"
        classNames={[styles.button]}
        onClick={() =>
          dispatch(
            openModal(ModalType.SEND_SECURE_MESSAGE, {
              patientId,
            }),
          )
        }
      />
    </div>
  );
};

SecureMessagingSend.propTypes = {
  patientId: PropTypes.number.isRequired,
};

export default SecureMessagingSend;
